import { RootState } from "../../../store";
import { AccountPageStateType } from "../../accountSlice";

export const currentAccountPageStateSelector = (
  state: RootState,
): AccountPageStateType => state.account.state;
